import React from "react"
import { atLeastChecked } from "./validators"
import { FormattedMessage } from "react-intl"
import { Icon } from "@walmart-web/livingdesign-icons"
import "./ErrorMessage.scss"

const ErrorMessage: React.FC<{
	items: Array<string>
}> = ({ items }) => {
	const [error, message] = atLeastChecked(items)
	return (
		<>
			{error && (
				<div className="error-message">
					<FormattedMessage id={message} />
					<Icon name="ExclamationCircleFill" />
				</div>
			)}
		</>
	)
}

export default ErrorMessage
